module.exports = __webpack_public_path__ + "static/media/PDF_101.d9fea0b4.pdf";